import React, { Fragment } from "react";
import { isNonBlur } from "helpers";
import classNames from "classnames";
import { Trans } from "react-i18next";

const CatchStoryInfo = ({ vod, compareBroadDate, location }) => {
    const aVodBroadDate = vod.broad_date.split("-");
    const month = aVodBroadDate[1];
    const day = aVodBroadDate[2];
    // 스토리 순서 노출되지 않아야하는 캐치스토리 섹션 위치 (vod_all : VOD탭 전체 VOD, home : 홈탭)
    const noOrderLocation = ['vod_all', 'home'];

	return (
		<Fragment>
            <div className={classNames("catch-story-info", isNonBlur() ? "blur_remove" : "")}>
                    <div className="date">
                    {/* 제목 영역 */}
                    <p className="title"><span>{month}<Trans>월</Trans></span>{day}</p>
                </div>
            </div>
            
            {/* 
            * 순서가 1이 아니라면 무조건 표기
            * 순서가 1인데 표기해야하는 케이스
            * 1. 최신 순일때 현재 broad_date와 이전 스토리의 broad_date가 같을 경우
            * 2. 오래된 순일떄 현재 broad_date와 다음 스토리의 broad_date가 같을 경우
            * ※ 이전 스토리의 broad_date와 다음 스토리의 broad_date는 orderby에 따라 CatchsList 에서 계산하여 내려준다.
            */}
            { (!noOrderLocation.includes(location) && (vod.order != 1 || compareBroadDate == vod.broad_date)) && (
                <div className="story_order">
                    {/* 순서 영역 */}
                    <span>#{vod.order}</span>
                </div>
            )}
		</Fragment>
	);
};

export default CatchStoryInfo;
